export default __webpack_public_path__ + "static/media/asl-project.faed53e1.jpg";